import React from 'react';
import { withTranslation } from '../../lib/translate';
import { IonButton} from '@ionic/react';
import Keyboard from 'react-simple-keyboard';
import Modal from '../modal';
import Basket from '../../lib/basket';
import { Spacer, Subtitle, Title } from '../common';
import './index.css';

class TableNumberModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tableNumber: null,
			modalOpen: true,
		};
	}
	onChange = (val) => {
		this.setState({ tableNumber: val == '' ? null : val });
	};
	render() {
		const { __ } = this.props;
		const { tableNumber, modalOpen } = this.state;
		return (
			<Modal className="table-number-modal text-centered" isOpen={modalOpen} backdropDismiss={false}>
				<div className='large-padding'>
					<div className='centered'>
						<Title >
							{__('Enter your table number')}
						</Title>
					</div>
					<Spacer size={2} />
					<div style={{ height: 'var(--large-fields-height)', alignItems: 'center', display: 'flex' }} lines="none" className="full-width centered input-field-wrapper input-field-wrapper-large">

						<Subtitle style={{lineHeight:1}} className={'text-centered block'}>{tableNumber ?? __('Table number')}</Subtitle>

					</div>


					<Spacer size={3} />
			<div className='keyboard-wrapper'>
					<Keyboard
						layout={{
							default: ['1 2 3', '4 5 6', '7 8 9', ' 0 ', '{bksp}'],
						}}
						display={{
							'{bksp}': __('Delete'),
						}}
						maxLength={6}
						onChange={this.onChange}
					/>
					</div>
					<Spacer size={3} />
					<IonButton
						className="large-button full-width"
						disabled={!tableNumber}
						expand="block"
						onClick={() => {
							this.setState({ modalOpen: false }, () => Basket.setTableNumber(tableNumber));
						}}
					>
						{__('Continue')}
					</IonButton>
				</div>
			</Modal>
		);
	}
}

export default withTranslation(TableNumberModal);
